(function($) {
  var collectionCarouselSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: '<button class="arrow-angle right-arrow" style="display: block;"><img style="display:block; width: 100%" src="https://cdn.shopify.com/s/files/1/0273/4214/3566/files/chevron-left.svg?v=1602109866"></button>',
    prevArrow: '<button class="arrow-angle left-arrow" style="display: block;"><img style="display:block; width: 100%" src="https://cdn.shopify.com/s/files/1/0273/4214/3566/files/chevron-right.svg?v=1602109866"></button>',
    touchThreshold: 15,
    speed: 300,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          touchThreshold: 15,
          speed: 300
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          touchThreshold: 15,
          speed: 300
        }
      }
    ]
  };

  var collectionRowCarouselSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: '<button class="arrow-angle right-arrow" style="display: block;"><img style="display:block; width: 100%" src="https://cdn.shopify.com/s/files/1/0273/4214/3566/files/chevron-left.svg?v=1602109866"></button>',
    prevArrow: '<button class="arrow-angle left-arrow" style="display: block;"><img style="display:block; width: 100%" src="https://cdn.shopify.com/s/files/1/0273/4214/3566/files/chevron-right.svg?v=1602109866"></button>',
    touchThreshold: 15,
    speed: 300,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          touchThreshold: 15,
          speed: 300
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          touchThreshold: 15,
          speed: 300
        }
      }
    ]
  };

  function initSlick($elements, settings) {
    if (!$elements.length || typeof $elements.slick !== 'function') {
      return;
    }

    $elements.each(function() {
      var $element = $(this);
      if ($element.hasClass('slick-initialized')) {
        return;
      }

      $element.slick(settings);
    });
  }

  function destroySlick($scope, selector) {
    $scope.find(selector).each(function() {
      var $element = $(this);
      if ($element.hasClass('slick-initialized')) {
        $element.slick('unslick');
      }
    });
  }

  function initCollectionCarousels($scope) {
    var $root = $scope && $scope.length ? $scope : $(document);
    initSlick($root.find('.collection-carousel'), collectionCarouselSettings);
    initSlick($root.find('.collection-row-carousel'), collectionRowCarouselSettings);
  }

  $(document).ready(function() {
    $('[read-more-link]').on('click', function(e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('expanded');
      $this.html($this.hasClass('expanded') ? 'Read less' : 'Read more');
    });

    initCollectionCarousels();
  });

  $(document).on('shopify:section:load', function(event) {
    initCollectionCarousels($(event.target));
    mobile__quickAddToCart();
  });

  $(document).on('shopify:section:unload', function(event) {
    var $target = $(event.target);
    destroySlick($target, '.collection-carousel');
    destroySlick($target, '.collection-row-carousel');
  });
})(jQuery);
theme.Collection = (function() {
  function Collection(container) {

  $('ul.sidebar-accordion').find('li.extend').click(function(){
    //Expand or collapse this panel
    $(this).next().slideToggle('fast');
    //Hide the other panels
    $("ul.extended-submenu").not($(this).next()).slideUp('fast');
  });

  }
  Collection.prototype = _.assignIn({}, Collection.prototype, {});

  return Collection;
  
})();
 const mobile__quickAddToCart  = function(){
  const mobile_addToCart_elements = document.querySelectorAll("[mobile-quick-add-cart]");
  [...mobile_addToCart_elements].forEach(function(element){
    let show_swatches = false;
    const product_id = element.getAttribute("quick-add-product");
    const m_quickAdd_container = document.querySelector(`[quick-add-product="${product_id}"]`)
    const m_quickAdd_formSwatch =  m_quickAdd_container.querySelector(`form.product-form-${product_id}`);
    const m_quickAdd_formSwatch_inputs = m_quickAdd_formSwatch.querySelectorAll(".content .swatch-element input");
    const mobile_fake_addToCart = document.createElement("div");
    const mobile_fake_addToCart_label = document.createTextNode("Add to cart");
    mobile_fake_addToCart.appendChild(mobile_fake_addToCart_label);
    mobile_fake_addToCart.setAttribute('class','mobile_fake_addToCart');
    mobile_fake_addToCart.setAttribute('onclick','$(this).remove()');
    
    if(m_quickAdd_formSwatch_inputs.length > 0){
      for(let input of [...m_quickAdd_formSwatch_inputs]){
        let value = String(input.value).toLocaleLowerCase();
        if( value === 's' || value === 'm' || value === 'l' || value === '5' || value === '6' || value === '7' || value === '8' || value === '9'){
          show_swatches = true;        
          break;
        }
      }      
    }
    if (show_swatches) {
      m_quickAdd_formSwatch.classList.add("show_size_swatches");
      m_quickAdd_formSwatch.parentNode.insertBefore(mobile_fake_addToCart, m_quickAdd_formSwatch);
      document.querySelector(`#form--quick-atc-${product_id}`).classList.add("mobile_hide_cta")
    }
  })
}
$(document).ready(function() {
  theme.sections = theme.sections || new theme.Sections();
  theme.sections.register('collection-section', theme.Collection);
  mobile__quickAddToCart();
});
